import { useEffect, useState } from "react";
import { api_private_get } from "script";
import { formatStringAmountUSD } from "script";
import { Link } from "react-router-dom";
import "./CryptoPricesPage.css";

const CRYPTO_ICON_FALLBACK = `data:image/svg+xml;utf8,${encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stop-color="#24304f"/>
            <stop offset="100%" stop-color="#10182f"/>
        </linearGradient>
    </defs>
    <rect width="24" height="24" rx="12" fill="url(#g)"/>
    <circle cx="12" cy="12" r="9.25" stroke="rgba(255,255,255,0.22)" stroke-width="1.5"/>
    <path d="M12 6.5v11M6.5 12h11" stroke="rgba(255,255,255,0.2)" stroke-width="1.2" stroke-linecap="round"/>
</svg>
`)}`;

// const SUPPORTED_CURRENCY_CODES = [
//     'BTC', 'ETH', 'USDT', 'XRP', 'BNB', 'SOL', 'USDC', 'TRX', 'DOGE', 'ADA', 'HYPE', 'BCH', 'SUI',
//     'LINK', 'LEO', 'AVAX', 'XLM', 'TON', 'SHIB', 'LTC', 'HBAR', 'XMR', 'DOT', 'DAI', 'USDE', 'BGB',
//     'UNI', 'PEPE', 'AAVE', 'PI', 'APT', 'TAO', 'OKB', 'NEAR', 'ICP', 'ETC', 'CRO', 'ONDO', 'USD1',
//     'KAS', 'MNT', 'POL', 'GT', 'VET', 'TRUMP', 'ARB', 'SKY', 'RENDER', 'ENA', 'FET', 'SEI', 'ATOM',
//     'FIL', 'ALGO', 'WLD', 'FDUSD', 'KCS', 'JUP', 'QNT', 'SPX', 'BONK', 'FLR', 'FARTCOIN', 'FORM',
//     'INJ', 'STX', 'OP', 'VIRTUAL', 'TIA', 'PYSUD', 'KAIA', 'XDC', 'PENGU', 'PAXG', 'S', 'WIF',
//     'GRT', 'IMX', 'IP', 'JTO', 'XAUT', 'NEXO', 'A', 'CAKE', 'FLOKI', 'AERO', 'CRV', 'ENS', 'THETA',
//     'LDO', 'ZEC', 'JASMY', 'GALA', 'DEXE', 'SYRUP', 'IOTA', 'SAND', 'PYTH', 'BTT', 'PENDLE',
// ];

function formatMarketCap(marketCap) {
  if (marketCap >= 1e12) {
    return (marketCap / 1e12).toFixed(2) + "T";
  } else if (marketCap >= 1e9) {
    return (marketCap / 1e9).toFixed(2) + "B";
  } else if (marketCap >= 1e6) {
    return (marketCap / 1e6).toFixed(2) + "M";
  } else if (marketCap >= 1e3) {
    return (marketCap / 1e3).toFixed(2) + "K";
  } else if (marketCap > 1) {
    return marketCap.toFixed(2) + " ";
  } else {
    return "N/A";
  }
}

function formatCryptoPrice(price) {
  const priceFloat = parseFloat(price);
  if (isNaN(priceFloat)) {
    return "N/A";
  }
  if (priceFloat > 1.2) {
    return formatStringAmountUSD(priceFloat);
  } else {
    // take 4 significant digits
    // price is string
    const formattedPrice = priceFloat.toPrecision(4);
    return formattedPrice + " USD";
  }
}

function formatDvol(value) {
  if (value === null || value === undefined) {
    return "-";
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "-";
  }

  if (numericValue === 0) {
    return "-";
  }

  return `${numericValue.toFixed(2)}%`;
}

function CurrencyRow({ currency, rank }) {
  const iconSrc = `/assets/images/icon/crypto_64x64/${currency.code.toLowerCase()}.png`;

  return (
    <tr key={currency.code}>
      <td className="text-nowrap font-monospace">{rank}</td>
      <td className="text-nowrap">
        <img
          src={iconSrc}
          alt={currency.name}
          className="crypto-prices-icon"
          onError={(event) => {
            event.currentTarget.onerror = null;
            event.currentTarget.src = CRYPTO_ICON_FALLBACK;
          }}
        />
        {currency.code.toUpperCase()}
      </td>
      <td className="text-nowrap">{currency.name}</td>
      <td className="text-nowrap fw-bold">
        ${formatCryptoPrice(currency.last_price)}
      </td>
      {/* <td className="text-nowrap">{currency.market_cap}</td> */}
      {/* <td className="text-nowrap r1-color fw-normal cpoint">{currency.last_price_time}</td> */}
      <td className="text-nowrap fw-bold">
        ${formatMarketCap(currency.circulating_supply * currency.last_price)}
      </td>

      <td className="text-nowrap fw-bold">{formatDvol(currency.volState?.vol30d)}</td>
      {currency.code === "ETH" ||
      currency.code === "BTC" ||
      currency.code === "SOL" ||
      currency.code === "DOGE" ? (
        <td className="text-nowrap">
          <Link to={`/market?currency=${currency.code}`}>
            <button className="btn btn-primary crypto-market-button">
              {currency.code} Market
            </button>
          </Link>
        </td>
      ) : (
        <td>Not avaliable</td>
      )}
    </tr>
  );
}

const CryptoPricesPage = () => {
  const [cryptoPrices, setCryptoPrices] = useState([]);
  const [lastUpdated, setLastUpdated] = useState(new Date().toLocaleString());

  function loadCryptoPrices() {
    // This is where you would fetch the latest cryptocurrency prices
    // For now, we will just log a message to the console
    console.log("Fetching latest cryptocurrency prices...");
    // You can replace this with an actual API call to fetch prices

    api_private_get("/market/get_currency_prices", (data) => {
      console.log("Crypto prices data:", data);
      // Here you would update the state with the fetched data

      // Filter out supported currencies IN ORDER
      const filteredData = data.filter(
        (currency) =>
          // SUPPORTED_CURRENCY_CODES.includes(currency.code.toUpperCase())
          currency.circulating_supply * currency.last_price > 1e6,
      );
      // Sort by the order of SUPPORTED_CURRENCY_CODES
      filteredData.sort((a, b) => {
        const aMarketCap = a.circulating_supply * a.last_price;
        const bMarketCap = b.circulating_supply * b.last_price;
        return bMarketCap - aMarketCap;
      });

      setCryptoPrices(filteredData);
      setLastUpdated(new Date().toLocaleString());
    });
  }

  useEffect(() => {
    loadCryptoPrices();

    // periodically check the products for the selected bet
    const interval = setInterval(() => {
      console.log("Checking for cryptocurrency prices...");
      loadCryptoPrices();
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="container-fluid mt-5 crypto-prices-page">
        <h1 className="mb-4">Crypto Prices</h1>
        <p>This page will display the latest cryptocurrency prices.</p>
        <div className="alert alert-warning crypto-volatility-note" role="alert">
          Volatility is calculated from the currently stored samples and is shown immediately, even when the sample set is small.
          Early values can be noisy, especially before a full window of 1-minute history has accumulated.
        </div>
        <p className="mb-4">Updated on: {lastUpdated}</p>
        <div className="crypto-prices-table-shell">
          <div className="crypto-prices-table-scrollbar">
            <table
              className="w-100 text-center p2-bg crypto-prices-table"
              id="crypto-prices-table"
            >
              <thead>
                <tr>
                  <th className="text-nowrap">Rank</th>
                  <th className="text-nowrap">Symbol</th>
                  <th className="text-nowrap">Name</th>
                  <th className="text-nowrap">Price (USD)</th>
                  <th className="text-nowrap">Market Cap (USD)</th>
                  <th className="text-nowrap">DVOL 30d (%/yr)</th>
                  <th className="text-nowrap">View Market</th>
                </tr>
              </thead>
              <tbody>
                {/* {accountOrdersData?.length === 0 && (
                                    <tr>
                                        <td colSpan="5" className="text-start">There are no holdings in your account for the moment...</td>
                                    </tr>
                                )} */}
                {Array.isArray(cryptoPrices) &&
                  cryptoPrices.map((currency, idx) => (
                    <CurrencyRow
                      key={currency.code}
                      currency={currency}
                      rank={idx + 1}
                    />
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default CryptoPricesPage;
